import * as React from 'react';
import { ContentState } from 'draft-js';
import { DividerEntityData } from '../StyleControls';

interface IProps {
  contentState: ContentState;
  entityKey: string;
  blockKey: string;
  updateEntityData?: (newContentState: ContentState, changeType?: string) => void;
}

export const DividerBlock: React.FC<IProps> = React.memo((props) => {
  const { contentState, entityKey } = props;
  const entity = contentState.getEntity(entityKey);
  const data: DividerEntityData = entity.getData();
  const {
    style = 'solid',
    color = '#cccccc',
    thickness = 1,
    alignment = 'center',
    width = '100%'
  } = data;

  const dividerStyle: React.CSSProperties = {
    borderTop: `${thickness}px ${style} ${color}`,
    width,
    margin: '16px auto',
    display: 'block',
    textAlign: alignment as 'left' | 'center' | 'right',
  };

  // For left/right alignment, adjust margin
  if (alignment === 'left') {
    dividerStyle.marginLeft = '0';
    dividerStyle.marginRight = 'auto';
  } else if (alignment === 'right') {
    dividerStyle.marginLeft = 'auto';
    dividerStyle.marginRight = '0';
  }

  return (
    <div
      style={dividerStyle}
      role="separator"
      aria-label="Content divider"
      data-divider="true"
    />
  );
});

DividerBlock.displayName = 'DividerBlock';
